import PropTypes from "prop-types";
import React, { useState } from "react";

import { ConfigurationProvider } from "../ConfigurationContext";

/**
 * StickyContainer is used as the parent of the Sticky component to provide
 * scrolling allowance for sticky elements in the browser. This makes it so that
 * Sticky elements have enough space in the DOM to scroll past and allow for all
 * content to be present on the screen.
 */
export const StickyContainer = (props) => {
  const { className, children } = props;
  const [stickyOffset, setStickyOffset] = useState(null);
  const [stickyElementHeight, setStickyElementHeight] = useState(0);

  return (
    <ConfigurationProvider configuration={{ registerStickyElement }}>
      <div className={className} style={getStickyContainerStyling()}>
        {children}
      </div>
    </ConfigurationProvider>
  );

  function getStickyContainerStyling() {
    return {
      marginBottom:
        stickyOffset?.bottom !== undefined ? stickyElementHeight + stickyOffset.bottom : undefined,
      marginTop:
        stickyOffset?.top !== undefined ? stickyElementHeight + stickyOffset.top : undefined,
    };
  }

  function registerStickyElement(stickyElement, offset) {
    if (stickyElement) {
      setStickyElementHeight(stickyElement.getBoundingClientRect().height);
      setStickyOffset(offset);
    } else {
      setStickyElementHeight(0);
      setStickyOffset(null);
    }
  }
};

StickyContainer.displayName = "StickyContainer";

StickyContainer.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,

  /** Additional class names to apply to the container. */
  className: PropTypes.string,
};
